import { cn } from '@/lib/cn';

interface SliderProps {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  format?: (v: number) => string;
  showValue?: boolean;
}

export function Slider({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled,
  className,
  format,
  showValue = true,
}: SliderProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
        className="flex-1"
      />
      {showValue && (
        <span className="text-xs font-mono text-fg-muted tabular-nums min-w-[3ch] text-right">
          {format ? format(value) : value}
        </span>
      )}
    </div>
  );
}
